(function () {
  const animateMegaMenu = (header) => {
    const menu = header.querySelector(".list-menu--inline");
    const menuLinks = header.querySelectorAll(".list-menu-item");
    const megaMenus = header.querySelectorAll(".mega-menu");
    const mobileMegaMenus = header.querySelectorAll(".mobile-mega-menu");

    if (
      !megaMenus ||
      !menuLinks ||
      menuLinks.length === 0 ||
      megaMenus.length === 0
    ) {
      return;
    }

    const closeMenuDisclosure = () => {
      const disclosures = header.querySelectorAll("details-disclosure");
      if (customElements.get("details-disclosure")) {
        disclosures.forEach((disclosure) => {
          disclosure.close();
        });
      }

      const disclosureLists = header.querySelectorAll(".disclosure__list");
      disclosureLists.forEach((disclosureList) => {
        disclosureList.setAttribute("hidden", true);
      });
    };

    // A panel's product groups: the row's own (data-mega-menu-products-for="N") and one per
    // sub-menu item ("N-k"). Show the one for `key` (the sub item's id), or — key null —
    // the panel's default: the row's own, else the group marked by the active sub item.
    const showProductGroup = (panel, key) => {
      if (!panel) return;
      const groups = panel.querySelectorAll("[data-mega-menu-products-for]");
      if (!groups.length) return;
      const tabId = panel.dataset.megaMenuTabId;
      let target = key && panel.querySelector(`[data-mega-menu-products-for='${key}']`);
      if (!target) {
        const defaultSub = panel.querySelector(".mega-menu__subnav-item[data-default-sub]");
        target =
          panel.querySelector(`[data-mega-menu-products-for='${tabId}']`) ||
          (defaultSub && panel.querySelector(`[data-mega-menu-products-for='${defaultSub.dataset.megaMenuSubId}']`)) ||
          groups[0];
      }
      groups.forEach((group) => {
        group.hidden = group !== target;
      });
      const shownKey = target.dataset.megaMenuProductsFor;
      panel.querySelectorAll(".mega-menu__subnav-item").forEach((item) => {
        item.classList.toggle("mega-menu__subnav-item--active", item.dataset.megaMenuSubId === shownKey);
      });
    };

    const showSubProducts = (item) => {
      showProductGroup(item.closest(".mega-menu__media"), item.dataset.megaMenuSubId);
    };

    // A panel's sub menu opens at its row's height, as the live site's nested dropdown
    // opens beside its parent item (owner 2026-10-02): its offset from the list's top.
    // Also as wide as the list (owner 2026-10-02).
    const alignSubnav = (panel, row) => {
      if (!panel || !row || !panel.querySelector(".mega-menu__subnav-wrap")) return;
      const list = row.parentElement.getBoundingClientRect();
      const offset = row.getBoundingClientRect().top - list.top;
      panel.style.setProperty("--mega-subnav-offset", `${Math.max(0, Math.round(offset))}px`);
      panel.style.setProperty("--mega-subnav-width", `${Math.round(list.width)}px`);
    };

    const animateSubmenuLinks = (megaMenu) => {
      if (!megaMenu) return;
      const submenu = megaMenu.querySelector(".mega-menu__submenu");
      const mediaBlocks = megaMenu.querySelectorAll(".mega-menu__media");
      if (!submenu) return;
      const sublinks = submenu.querySelectorAll(".mega-menu__submenu-link");

      const removeActiveClass = () => {
        sublinks.forEach((sublink) => {
          sublink.classList.remove("mega-menu__submenu-link--active");
        });

        mediaBlocks.forEach((block) => {
          block.classList.remove("mega-menu__media--active");
          block.removeAttribute("style");
        });
      };

      const resetActiveClass = () => {
        removeActiveClass();
        // Back to the first row that IS a tab and its own products. A row whose tab has no
        // products is a plain link without a tab id; pairing "first row" with "first
        // products" (the theme's way) then underlined one row and showed another's products.
        const firstTab = [...sublinks].find((sublink) => sublink.dataset.megaMenuTabId);
        if (!firstTab) return;
        firstTab.classList.add("mega-menu__submenu-link--active");
        const media = megaMenu.querySelector(
          `.mega-menu__media[data-mega-menu-tab-id='${firstTab.dataset.megaMenuTabId}']`
        );
        if (media) {
          media.classList.add("mega-menu__media--active");
          media.style.display = "flex";
          alignSubnav(media, firstTab);
          showProductGroup(media, null);
        }
      };

      const toggleActive = (sublink) => {
        // Nav-driven left links (the Main menu dropdown) are plain links, not tabs:
        // they carry no tab id. Without this guard, hovering one cleared EVERY media
        // block on the right and then found nothing to show — the products vanished.
        const tabId = sublink.getAttribute("data-mega-menu-tab-id");
        if (!tabId) return;
        if (sublink.classList.contains("mega-menu__submenu-link--active")) {
          return;
        }
        removeActiveClass();
        sublink.classList.add("mega-menu__submenu-link--active");
        const needMedia = megaMenu.querySelector(
          `.mega-menu__media[data-mega-menu-tab-id='${tabId}']`
        );
        if (!needMedia) return;
        needMedia.style.display = "flex";
        // At once: the theme added this 150 ms later for a fade, but the fade never runs
        // (--duration-default is undefined — see base.css line 1), so the panel was simply
        // blank for 150 ms on every row change.
        needMedia.classList.add("mega-menu__media--active");
        alignSubnav(needMedia, sublink);
        // A row shown again starts from its own products, not the sub item hovered last time.
        showProductGroup(needMedia, null);
      };

      // Every open: the panel shown by default gets its sub menu at its row's height.
      const activeRow = submenu.querySelector(".mega-menu__submenu-link--active");
      if (activeRow) {
        alignSubnav(
          megaMenu.querySelector(`.mega-menu__media[data-mega-menu-tab-id='${activeRow.dataset.megaMenuTabId}']`),
          activeRow
        );
      }

      // This runs on EVERY open (from setDisplayStyles); bind the listeners once only,
      // or each hover stacks another copy of them.
      if (megaMenu.dataset.submenuBound) return;
      megaMenu.dataset.submenuBound = "1";

      // The pointer's last few positions inside this mega menu — for the menu aim below.
      const moves = [];
      let lastMoveAt = 0;
      megaMenu.addEventListener(
        "mousemove",
        (e) => {
          moves.push({ x: e.clientX, y: e.clientY });
          if (moves.length > 3) moves.shift();
          lastMoveAt = performance.now();
        },
        { passive: true }
      );

      // Menu aim (the technique of Amazon's mega menu), for a vertical list with a panel on
      // its right: the left list → its sub menu / products, and each sub menu → its products.
      // On the way to the panel the cursor often crosses the items below or above the one
      // it left, and switching on every item it touched swapped the panel before it got
      // there. So while the cursor is still moving toward the list's right edge, a switch
      // waits AIM_DELAY_MS and is judged again; when it rests on an item, or moves any
      // other way (down the list, back left), it switches at once.
      // 200ms (Amazon uses 300): the owner felt the wait as a lag ("kasni odziv", 2026-10-02);
      // a stop is still caught within ~60ms by the re-check below.
      const AIM_DELAY_MS = 200;
      const AIM_TOLERANCE = 75; // px above / below the list still counted as "toward the panel"
      // getPanel: the panel the list leads to. The "toward the panel" zone spans the list
      // AND that panel vertically — with the list's rows only (±75px), aiming at the lower
      // half of a product card read as "not toward the panel" and switched rows on the way
      // (review 2026-10-02: Power Wire's 3 rows vs cards reaching ~180px lower).
      const createAim = (listEl, activate, getPanel) => {
        let timer = null;
        let pending = null;

        // `at`: the pointer position of the event being judged. An item's mouseenter fires
        // BEFORE the mousemove that carried the pointer there, so without it a fast move
        // was judged on the positions before the jump (measured: a 25px-per-frame diagonal
        // read as "not toward the panel" and switched rows).
        const headingRight = (at) => {
          const cur = at || moves[moves.length - 1];
          const prev = moves[0];
          if (!cur || !prev || (cur.x === prev.x && cur.y === prev.y)) return false;
          const r = listEl.getBoundingClientRect();
          if (cur.x >= r.right || prev.x >= r.right) return false;
          const panel = getPanel && getPanel(listEl);
          const pr = panel ? panel.getBoundingClientRect() : r;
          const upper = { x: r.right, y: Math.min(r.top, pr.top) - AIM_TOLERANCE };
          const lower = { x: r.right, y: Math.max(r.bottom, pr.bottom) + AIM_TOLERANCE };
          const slope = (a, b) => (b.y - a.y) / (b.x - a.x);
          // Moving toward the panel, the slope to the upper corner falls and the slope to
          // the lower corner rises (straight down, or to the left, breaks one of them).
          return slope(cur, upper) < slope(prev, upper) && slope(cur, lower) > slope(prev, lower);
        };

        const cancel = () => {
          clearTimeout(timer);
          timer = null;
          pending = null;
        };

        // From mouseenter (`at` set): heading for the panel → wait AIM_DELAY_MS, else switch.
        // From the timer (no `at`): the pointer has stopped (no move for 60ms) → switch now;
        // still moving toward the panel → look again in 60ms. Re-arming a full 300ms on
        // stale positions made a stop switch only 0.3–0.6s later (review 2026-10-02).
        const request = (item, at) => {
          cancel();
          if (!at && performance.now() - lastMoveAt >= 60) {
            activate(item);
            return;
          }
          if (headingRight(at)) {
            pending = item;
            timer = setTimeout(() => request(item), at ? AIM_DELAY_MS : 60);
            return;
          }
          activate(item);
        };

        // Left the item before its switch fired: into the panel (keep what is shown) or
        // onto another item (whose own mouseenter decides).
        const leave = (item) => {
          if (pending === item) cancel();
        };

        return { request, leave, cancel };
      };

      const rowAim = createAim(
        submenu,
        toggleActive,
        () => megaMenu.querySelector(".mega-menu__media--active") || megaMenu.querySelector(".mega-menu__block--right")
      );
      sublinks.forEach((sublink) => {
        sublink.addEventListener("mouseenter", (e) => rowAim.request(sublink, { x: e.clientX, y: e.clientY }));
        sublink.addEventListener("mouseleave", () => rowAim.leave(sublink));
      });

      // Sub-menu items with products of their own (owner 2026-10-02): hovering one shows
      // its collection's products in place of the row's.
      const subAims = [];
      megaMenu.querySelectorAll(".mega-menu__subnav").forEach((subnav) => {
        const aim = createAim(subnav, showSubProducts, (list) =>
          list.closest(".mega-menu__media")?.querySelector(".mega-menu__media-main")
        );
        subAims.push(aim);
        subnav.querySelectorAll(".mega-menu__subnav-item[data-mega-menu-sub-id]").forEach((item) => {
          item.addEventListener("mouseenter", (e) => aim.request(item, { x: e.clientX, y: e.clientY }));
          item.addEventListener("mouseleave", () => aim.leave(item));
        });
      });

      megaMenu.addEventListener("mouseleave", () => {
        rowAim.cancel();
        subAims.forEach((aim) => aim.cancel());
        resetActiveClass();
      });
    };

    const setDisplayStyles = (megaMenu) => {
      megaMenu.setAttribute("open", "true");
      header.classList.add("header-sticky-with-opened-mega-menu");
      //document.body.classList.add("overflow-hidden-drawer");
      closeMenuDisclosure();
      animateSubmenuLinks(megaMenu);
    };

    const setHiddenStyles = (megaMenu) => {
      //document.body.classList.remove("overflow-hidden-drawer");
      megaMenu.removeAttribute("open");
      header.classList.remove("header-sticky-with-opened-mega-menu");
    };

    const checkMenuPosition = (megaMenu) => {
      const modalWindow = megaMenu?.querySelector(".mega-menu__wrapper");
      if (!modalWindow) return;
      // The wrapper is `position: fixed`, BUT the sticky header is transformed, so
      // fixed is resolved against THAT ancestor, not the viewport. Find the nearest
      // ancestor that creates a containing block (transform/perspective/filter) and
      // subtract its top, so the box lands exactly at the header's real bottom.
      // Read live on every open → follows a resized / sticky-shrunk header. −2px so
      // there is never a sub-pixel gap (dead space that would drop the hover).
      let cb = modalWindow.parentElement;
      while (cb) {
        const s = getComputedStyle(cb);
        if (s.transform !== "none" || s.perspective !== "none" || s.filter !== "none") break;
        cb = cb.parentElement;
      }
      const cbRect = cb ? cb.getBoundingClientRect() : { top: 0, left: 0 };

      // Horizontal: span the header's content column (where the logo, menu and icons
      // sit), so the box hangs directly under the menu yet stays centred on the page.
      // A viewport-centred box left the first menu items hanging past its left edge
      // (moving straight down from them missed the box). Widen symmetrically if the
      // menu starts left of the column's padding, so every item has box beneath it.
      const container = header.querySelector(".header") || header;
      const cr = container.getBoundingClientRect();
      const ccs = getComputedStyle(container);
      const contentLeft = cr.left + parseFloat(ccs.paddingLeft);
      const contentRight = cr.right - parseFloat(ccs.paddingRight);
      const navLeft = menu ? menu.getBoundingClientRect().left : contentLeft;
      const centerX = (contentLeft + contentRight) / 2;
      const halfW = Math.max(centerX - Math.min(navLeft, contentLeft), contentRight - centerX);
      modalWindow.style.left = (centerX - halfW - cbRect.left) + "px";
      modalWindow.style.width = (2 * halfW) + "px";
      modalWindow.style.maxWidth = "none";
      modalWindow.style.transform = "none";

      // Vertical: flush under the header's real bottom (−2px, no sub-pixel gap).
      modalWindow.style.top = (header.getBoundingClientRect().bottom - cbRect.top - 2) + "px";

      // Hover bridge: when the nav item is shorter than the header (the menu wraps to
      // two rows at ~1265px), between its bottom and the box's top lies a strip of
      // plain header — crossing it fires the <li>'s mouseleave. Cover that strip (1px
      // overlap at both ends), but ONLY under the item itself: a box-wide bridge
      // covered the logo and the header icons while a menu was open. Diagonal moves
      // toward the rest of the box are handled by the "aiming" grace below.
      const bridge = megaMenu.querySelector(".mega-menu__bridge");
      const item = megaMenu.closest(".list-menu-item");
      if (bridge && item) {
        const itemRect = item.getBoundingClientRect();
        const boxRect = modalWindow.getBoundingClientRect();
        bridge.style.top = (itemRect.bottom - cbRect.top - 1) + "px";
        bridge.style.left = (itemRect.left - cbRect.left) + "px";
        bridge.style.width = itemRect.width + "px";
        bridge.style.height = Math.max(0, boxRect.top - itemRect.bottom + 2) + "px";
      }
    };

    const checkScrollProducts = (megaMenu) => {
      const productBlocks = [...megaMenu.querySelectorAll(".mega-menu__products")];
      // Read every block first, then write: toggling a class between two reads made the
      // browser lay the whole header out again for each block (a panel now holds a group
      // per sub-menu item).
      const scrolls = productBlocks.map((block) => block.scrollHeight > block.clientHeight);
      productBlocks.forEach((block, i) => {
        block.classList.toggle("mega-menu__products--scroll", scrolls[i]);
      });
    };

    const openMegaMenu = (link) => {
      if (link.classList.contains("list-menu--megamenu")) {
        link.classList.add("list-menu--megamenu-visible");

        megaMenus.forEach((megaMenu) => {
          if (megaMenu == link.querySelector(".mega-menu")) {
            // Open FIRST, then measure: a closed menu is display:none (base.css — so its
            // lazy images are not fetched until it opens), and every box / bridge / scroll
            // measurement below would read 0 on it. All in one task, so nothing paints in
            // between.
            setDisplayStyles(megaMenu);
            checkMenuPosition(megaMenu);
            checkScrollProducts(megaMenu);

            const overlay = megaMenu.querySelector(".mega-menu__overlay");
            const handleMouseLeaveWrapper = () => {
              setHiddenStyles(megaMenu);
              link.classList.remove("list-menu--megamenu-visible");
              overlay?.removeEventListener(
                "mouseenter",
                handleMouseLeaveWrapper
              );
            };
            overlay?.addEventListener("mouseenter", handleMouseLeaveWrapper);
          }
        });

        menuLinks.forEach((el) => {
          if (el !== link) {
            el.classList.remove("list-menu--megamenu-visible");
          }
        });
      } else {
        menuLinks.forEach((el) => {
          el.classList.remove("list-menu--megamenu-visible");
        });
      }
    };

    // Hover intent. Opening is instant, and so is CLOSING (owner 2026-10-02: the menu
    // must vanish the moment the mouse leaves it) — with ONE exception: a cursor that
    // leaves the nav item heading DOWN toward the box (diagonally, over a sibling item)
    // keeps the menu while it keeps heading there: a pending close fires only after
    // the cursor rests INTENT_MS, a pending switch to a sibling mega item after it
    // rests SWITCH_REST_MS on it. Leaving the box itself, or moving up / sideways
    // along the menu, acts at once. Coming back to the open item (its nav link, the
    // bridge or the box — all inside the same <li>) cancels any pending close or
    // switch. (Replaces the theme's per-item mouseleave close and the <ul> mouseleave
    // "close all".)
    const INTENT_MS = 220;
    // 100ms (was 150): the owner felt the wait as a lag on hover (2026-10-02).
    const SWITCH_REST_MS = 100;
    // A move heads for the box when it descends at least this steeply (dy ≥ 0.03·|dx|).
    // The box hangs only ~30px below the labels but spans the whole header, so a
    // diagonal to the far products descends as little as ~0.06; a sweep along the
    // menu row drifts less than that.
    const AIM_SLOPE = 0.03;
    // Direction is judged over at least AIM_SPAN px: from the point where the cursor
    // left the item once it is that far away (cumulative, so whole-pixel rounding no
    // longer matters), before that from the recent trail of the current movement (a
    // pause longer than AIM_PAUSE_MS starts a new one). Over one 8px step, a shallow
    // diagonal read as "sideways" (measured).
    const AIM_SPAN = 30;
    const AIM_PAUSE_MS = 150;
    let openItem = null;
    let closeTimer = null;
    let switchTimer = null;
    let switchTarget = null;
    let leavePoint = null;
    let lastClosedAt = -Infinity;
    const trail = []; // the last few pointer positions, document-wide

    const cancelTimers = () => {
      clearTimeout(closeTimer);
      clearTimeout(switchTimer);
      closeTimer = switchTimer = null;
      switchTarget = null;
      leavePoint = null;
    };

    const closeItem = (item) => {
      if (!item) return;
      item.classList.remove("list-menu--megamenu-visible");
      const megaMenu = item.querySelector(".mega-menu");
      if (megaMenu) setHiddenStyles(megaMenu);
      if (openItem === item) openItem = null;
      lastClosedAt = performance.now();
    };

    const closeNow = () => {
      cancelTimers();
      closeItem(openItem);
    };

    const showItem = (item) => {
      // Straight from another mega menu (open, or closed a moment ago by this same
      // move) → appear at once, no fade-in: the box would otherwise blink between them.
      const switching = (openItem && openItem !== item) || performance.now() - lastClosedAt < 300;
      cancelTimers();
      if (openItem && openItem !== item) closeItem(openItem);
      item.querySelector(".mega-menu")?.classList.toggle("mega-menu--instant", switching);
      openMegaMenu(item);
      openItem = item;
    };

    const scheduleClose = (item) => {
      clearTimeout(closeTimer);
      closeTimer = setTimeout(() => closeItem(item), INTENT_MS);
    };

    const scheduleSwitch = (item) => {
      clearTimeout(switchTimer);
      switchTarget = item;
      switchTimer = setTimeout(() => showItem(item), SWITCH_REST_MS);
    };

    const span = (a, b) => Math.abs(a.x - b.x) + Math.abs(a.y - b.y);

    // The current movement up to p: from the newest trail point at least AIM_SPAN
    // away — or, if the movement is shorter than that, from where it began.
    const recentMove = (p) => {
      let ref = null;
      let newerT = p.t;
      for (let i = trail.length - 1; i >= 0; i--) {
        if (newerT - trail[i].t > AIM_PAUSE_MS) break;
        ref = trail[i];
        newerT = ref.t;
        if (span(p, ref) >= AIM_SPAN) break;
      }
      return ref ? { dx: p.x - ref.x, dy: p.y - ref.y } : { dx: 0, dy: 0 };
    };

    // Is the cursor at p on its way into the open box? Only while it is still ABOVE the
    // box (in the menu row), within the box's width, not turning back up, and it has
    // descended steeply enough. Anything else — beside or below the box, going up,
    // sweeping along the menu — is leaving.
    const aimingAtBox = (p) => {
      const box = openItem?.querySelector(".mega-menu__wrapper");
      if (!box) return false;
      const r = box.getBoundingClientRect();
      // The box's top edge counts as "above" for a few px: it starts 2px above the
      // header's bottom (no sub-pixel gap), so when the menu wraps to two rows a
      // second-row nav link overlaps it and a cursor crossing that link, level with
      // the box top, was read as "beside the box" and closed the menu (measured).
      if (p.y >= r.top + 6 || p.x < r.left || p.x > r.right) return false;
      const recent = recentMove(p);
      if (recent.dy <= -3) return false; // turning back up toward the menu row
      const move = leavePoint && span(p, leavePoint) >= AIM_SPAN
        ? { dx: p.x - leavePoint.x, dy: p.y - leavePoint.y }
        : recent;
      // Too little movement to tell: give it the grace — the next mousemove (or the
      // timer, if the cursor stops) decides.
      if (Math.abs(move.dx) + Math.abs(move.dy) < 4) return true;
      return move.dy > 0 && move.dy >= AIM_SLOPE * Math.abs(move.dx);
    };

    // initHeader (below) re-runs on every theme-editor section event and calls this
    // again for the SAME header: bind the hover logic once per menu, or each run stacks
    // another copy of every listener. A re-rendered header has new elements, so it
    // binds afresh.
    const hoverBound = menuLinks[0].dataset.megaHoverBound === "1";
    menuLinks[0].dataset.megaHoverBound = "1";

    if (!hoverBound) menuLinks.forEach((link) => {
      const isMega = link.classList.contains("list-menu--megamenu");

      link.addEventListener("mouseenter", () => {
        if (!isMega) return; // passing over a plain item never closes the open menu by itself
        if (link === openItem) { cancelTimers(); return; }
        // A menu is still open here only while the cursor is heading for its box (see
        // mouseleave) — switch only if it stops on this item or turns away.
        if (!openItem) { showItem(link); return; }
        scheduleSwitch(link);
      });

      link.addEventListener("mouseleave", (e) => {
        if (link === openItem) {
          const p = { x: e.clientX, y: e.clientY, t: e.timeStamp };
          leavePoint = null; // judge this leave on its recent movement…
          if (aimingAtBox(p)) {
            leavePoint = p; // …and the rest of the journey from here, cumulatively
            scheduleClose(link);
          } else {
            closeNow();
          }
        } else if (isMega && switchTarget === link) {
          clearTimeout(switchTimer);
          switchTimer = null;
          switchTarget = null;
        }
      });
    });

    // While a close or switch is pending, every move re-decides: still heading for the
    // box → renew the grace; otherwise act NOW (switch to the item under the cursor if
    // it is a mega item, else close).
    if (!hoverBound) document.addEventListener(
      "mousemove",
      (e) => {
        const p = { x: e.clientX, y: e.clientY, t: e.timeStamp };
        if (openItem && (closeTimer || switchTimer) && !openItem.contains(e.target)) {
          if (aimingAtBox(p)) {
            if (closeTimer) scheduleClose(openItem);
            if (switchTimer && switchTarget) scheduleSwitch(switchTarget);
          } else if (switchTarget) {
            showItem(switchTarget);
          } else {
            closeNow();
          }
        }
        trail.push(p);
        if (trail.length > 40) trail.shift(); // enough for AIM_SPAN at 1px per event
      },
      { passive: true }
    );

    // rename color swatch inputs ids and labels for desktop mega menu
    megaMenus.forEach((megaMenu, index) => {
      const allMediaBlocks = megaMenu.querySelectorAll(".mega-menu__media");
      allMediaBlocks.forEach((block) => {
        const tabId = block.getAttribute("data-mega-menu-tab-id");

        block
          .querySelectorAll(".mega-menu__products-card")
          .forEach((productCard) => {
            // Per product GROUP, not per tab: a tab now holds its row's products and one group
            // per sub-menu item, and the same product can be in two of them.
            const groupKey =
              productCard.closest("[data-mega-menu-products-for]")?.dataset.megaMenuProductsFor || tabId;
            const allSwatchInputs = productCard.querySelectorAll(
              "input[type='radio']"
            );
            const allSwatchLabels =
              productCard.querySelectorAll("label.color-swatch");

            allSwatchInputs.forEach((input) => {
              const oldId = input.id;
              const oldName = input.name;
              input.id = `${oldId}-mega${index}-tab${groupKey}`;
              input.name = `${oldName}-mega${index}-tab${groupKey}`;
            });
            allSwatchLabels.forEach((label) => {
              const oldFor = label.htmlFor;
              label.htmlFor = `${oldFor}-mega${index}-tab${groupKey}`;
            });
          });
      });
    });

    // rename color swatch inputs ids and labels for mobile mega menu
    mobileMegaMenus.forEach((megaMenu, menuId) => {
      const allMobileItems = megaMenu.querySelectorAll(
        ".mobile-mega-menu__item"
      );
      allMobileItems.forEach((item, itemId) => {
        item
          .querySelectorAll(".mobile-mega-menu__products-card")
          .forEach((productCard) => {
            const allSwatchInputs = productCard.querySelectorAll(
              "input[type='radio']"
            );
            const allSwatchLabels =
              productCard.querySelectorAll("label.color-swatch");

            allSwatchInputs.forEach((input) => {
              const oldId = input.id;
              const oldName = input.name;
              input.id = `${oldId}-mob-mega${menuId}-item${itemId}`;
              input.name = `${oldName}-mob-mega${menuId}-tab${itemId}`;
            });
            allSwatchLabels.forEach((label) => {
              const oldFor = label.htmlFor;
              label.htmlFor = `${oldFor}-mob-mega${menuId}-item${itemId}`;
            });
          });
      });
    });
  };

  const closeMobileMenu = (header) => {
    const menuCloseBtn = header.querySelector(".header__modal-close-button");
    const mobileMenuDrawer = header.querySelector("header-drawer");
    menuCloseBtn.addEventListener("click", (e) => {
      mobileMenuDrawer.closeMenuDrawer(e);
    });
  };

  const onHoverRemoveOverlay = (event) => {
    if (
      window.innerWidth < 1200 ||
      !event.target?.closest(".shopify-section-header") ||
      event.target.closest(".shopify-section-header-sticky") ||
      event.target.closest(".header-sticky-with-opened-mega-menu")
    ) {
      return;
    }
    const header = event.target.closest(".shopify-section-header");
    header.classList.remove("color-background-overlay");
    header.classList.add("color-background-overlay-hidden");

    header.removeEventListener("mousemove", onMouseMove);
  };

  const onHoverAddOverlay = (event) => {
    if (
      window.innerWidth < 1200 ||
      !event.target?.classList.contains("shopify-section-header") ||
      event.target.classList.contains("shopify-section-header-sticky") ||
      event.target.classList.contains("header-sticky-with-opened-mega-menu")
    ) {
      return;
    }
    const searchModal = document.querySelector("header-search.header__search");
    const burgerMenu = document.querySelector("burger-menu");
    if (
      (searchModal && searchModal.hasAttribute("open")) ||
      (burgerMenu && burgerMenu.hasAttribute("opened"))
    ) {
      return;
    }
    event.target.classList.add("color-background-overlay");
    event.target.classList.remove("color-background-overlay-hidden");
  };

  const initHeaderOverlay = (header) => {
    const main = document.getElementById("MainContent");
    const sections = main.querySelectorAll(".shopify-section");

    if (sections.length > 0) {
      const sectionFirstChild = sections[0].querySelector(
        "[data-header-overlay='true']"
      );
      // selector with custom-liquid ".shopify-section-group-header-group, .shopify-section-group-overlay-group.custom-liquid-section"
      const headerGroupSections = document.querySelectorAll(
        ".shopify-section-group-header-group"
      );
      const breadcrumbs = document.querySelector(".breadcrumb");

      const removeColorScheme = (element) => {
        let classNames = element.getAttribute("class");
        classNames = classNames.replace(/color-background-\d+/g, "");
        element.setAttribute("class", classNames);
      };

      if (sectionFirstChild) {
        if (headerGroupSections[headerGroupSections.length - 1] === header) {
          sections[0].classList.add("section--has-overlay");
          sections[0].classList.remove("not-margin");
          header.classList.add("color-background-overlay");
          if (breadcrumbs) {
            removeColorScheme(breadcrumbs);
            const colorScheme =
              sectionFirstChild.getAttribute("data-color-scheme");
            if (colorScheme) breadcrumbs.classList.add(`color-${colorScheme}`);
          }
        } else {
          sections[0].classList.add("not-margin");
          header.classList.remove("color-background-overlay");
          header.removeEventListener("mouseenter", onHoverRemoveOverlay);
          header.removeEventListener("mouseleave", onHoverAddOverlay);
          if (breadcrumbs) removeColorScheme(breadcrumbs);
        }
      } else {
        header.classList.remove("color-background-overlay");
        header.removeEventListener("mouseenter", onHoverRemoveOverlay);
        header.removeEventListener("mouseleave", onHoverAddOverlay);
        if (breadcrumbs) removeColorScheme(breadcrumbs);
      }
    }
  };

  const onMouseMove = (event) => {
    onHoverRemoveOverlay(event);
  };

  const addListenersOnHeaderOverlay = (header) => {
    if (header && header.classList.contains("color-background-overlay")) {
      header.addEventListener("mouseenter", onHoverRemoveOverlay);
      header.addEventListener("mouseleave", onHoverAddOverlay);

      // get cursor position when page loading
      header.addEventListener("mousemove", onMouseMove);
    }
  };

  // Hamburger menu, FIRST level only (owner 2026-10-02): opening an item closes the one that
  // was open, and an item slides open and shut instead of snapping (the theme toggles the
  // <details> at once). A row's own panel (a sliding <menu-drawer>) and the theme's deeper
  // levels are left as they are. A tap on an item's NAME still follows its link — only a tap
  // elsewhere on the row (the caret) opens or closes it, as before.
  const initDrawerAccordion = (header) => {
    const list = header.querySelector(".menu-drawer__navigation > .menu-drawer__menu");
    if (!list || list.dataset.accordionBound === "1") return;
    list.dataset.accordionBound = "1"; // initHeader re-runs on every theme-editor event

    const SLIDE_MS = 300;
    const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
    const contentOf = (details) => details.querySelector(":scope > summary + *");

    // Animate the content's height from its current value to `to` (px), then run `done`.
    // A new slide on the same element cancels the one still running.
    const slide = (content, to, done) => {
      const run = content._slide;
      if (run) {
        clearTimeout(run.timer);
        content.removeEventListener("transitionend", run.onEnd);
      }
      const finish = () => {
        clearTimeout(state.timer);
        content.removeEventListener("transitionend", state.onEnd);
        content._slide = null;
        content.style.height = "";
        content.style.overflow = "";
        content.style.transition = "";
        done();
      };
      const state = {
        onEnd: (e) => {
          if (e.target === content && e.propertyName === "height") finish();
        },
        timer: 0,
      };
      content._slide = state;
      if (reduceMotion.matches) {
        finish();
        return;
      }
      content.style.overflow = "hidden";
      content.style.transition = "none";
      content.style.height = `${content.getBoundingClientRect().height}px`;
      content.offsetHeight; // apply the start height before the transition
      content.style.transition = `height ${SLIDE_MS}ms ease`;
      content.style.height = `${to}px`;
      content.addEventListener("transitionend", state.onEnd);
      state.timer = setTimeout(finish, SLIDE_MS + 100); // transitionend can be skipped
    };

    const openItem = (details) => {
      const content = contentOf(details);
      delete details.dataset.closing; // reopened while still sliding shut
      if (!content) {
        details.open = true;
        return;
      }
      // Its full height, measured with the height released: scrollHeight under a pinned
      // height read 0 for the theme's own dropdowns, whose inner list is height:100% +
      // overflow:auto — they then sat blank for 0.4 s and snapped (review 2026-10-02).
      const start = details.open ? content.getBoundingClientRect().height : 0;
      details.open = true;
      content.style.transition = "none";
      content.style.height = "auto";
      const target = content.getBoundingClientRect().height;
      content.style.height = `${start}px`;
      slide(content, target, () => {});
    };

    const closeItem = (details) => {
      const content = contentOf(details);
      if (!details.open || !content) {
        details.open = false;
        return;
      }
      details.dataset.closing = "1";
      slide(content, 0, () => {
        delete details.dataset.closing;
        details.open = false;
        details.classList.remove("menu-opening");
        // anything opened inside it goes shut with it
        details.querySelectorAll("details[open]").forEach((inner) => {
          inner.removeAttribute("open");
          inner.classList.remove("menu-opening");
        });
      });
    };

    list.addEventListener(
      "click",
      (e) => {
        const summary = e.target.closest("summary");
        const details = summary?.parentElement;
        if (!details || details.tagName !== "DETAILS" || details.parentElement?.parentElement !== list) return;
        if (e.target.closest("a")) return; // the item's name: follow its link
        e.preventDefault(); // we toggle it ourselves, with the slide
        const opening = !details.open || details.dataset.closing === "1";
        if (opening) {
          list.querySelectorAll(":scope > li > details[open]").forEach((other) => {
            if (other !== details) closeItem(other);
          });
          openItem(details);
          // the item above may shrink away under it — keep the tapped row in view (no
          // smooth scroll for "reduce motion")
          if (reduceMotion.matches) summary.scrollIntoView({ block: "nearest" });
          else setTimeout(() => summary.scrollIntoView({ block: "nearest", behavior: "smooth" }), SLIDE_MS + 20);
        } else {
          closeItem(details);
        }
      },
      true
    );
  };

  const initHeader = () => {
    const header = document.querySelector(".shopify-section-header");
    if (!header) return;

    animateMegaMenu(header);
    initDrawerAccordion(header);
    closeMobileMenu(header);
    initHeaderOverlay(header);
    addListenersOnHeaderOverlay(header);
  };

  initHeader();

  document.addEventListener("shopify:section:load", initHeader);
  document.addEventListener("shopify:section:unload", initHeader);
  document.addEventListener("shopify:section:reorder", initHeader);
})();

class BurgerMenu extends HTMLElement {
  constructor() {
    super();
    this.header = document.querySelector(".header-wrapper");
    this.headerLogo = this.header.querySelector(".header__heading-link");
    this.burgerMenu = this.querySelector(".burger-menu");
    this.toggleBtn = this.querySelector(".burger-menu__toggle");
    this.isOpen = false;

    if (this.header) this.header.preventHide = false;

    this.setListeners();
  }

  open() {
    if (this.header) this.header.preventHide = true;
    this.setAttribute("opened", "true");
    document.body.classList.add("overflow-hidden-drawer");
    this.burgerMenu?.addEventListener("transitionend", () => trapFocus(this), {
      once: true,
    });
    this.isOpen = true;
  }

  close() {
    document.body.classList.remove("overflow-hidden-drawer");
    this.removeAttribute("opened");
    if (this.header) this.header.preventHide = false;
    this.isOpen = false;
  }

  setListeners() {
    this.toggleBtn?.addEventListener("click", () => {
      if (this.isOpen) {
        this.close();
      } else {
        this.open();
      }
    });
    this.burgerMenu?.addEventListener("keyup", (event) => {
      event.code === "Escape" && this.close();
    });

    const resizeObserver = new ResizeObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.contentRect.width < 1200) {
          this.close();
        }
      });
    });

    resizeObserver.observe(this);
  }
}

if (!customElements.get("burger-menu")) {
  customElements.define("burger-menu", BurgerMenu);
}

class HeaderSearch extends HTMLElement {
  constructor() {
    super();
    this.header = document.querySelector(".header-wrapper");
    this.searchLink = this.querySelector(".header__icon--search");
    this.closeButton = this.querySelector(".header__search-close");
    this.overlayEl = this.querySelector(".header__search-overlay");
    this.modalContainer = this.querySelector(".header__search-inner");

    this.searchInput = this.querySelector("#Search-In-Modal");

    this.open = this.onOpen.bind(this);
    this.close = this.onClose.bind(this);
    this.handleKeyDown = this.onHandleKeyDown.bind(this);

    this.searchLink?.addEventListener("click", this.open);
    this.closeButton?.addEventListener("click", this.close);
    this.overlayEl?.addEventListener("click", this.close);
    this.header?.addEventListener("keydown", this.handleKeyDown);
  }

  onOpen(event) {
    event.preventDefault();
    if (this.header) this.header.preventHide = true;
    this.setAttribute("open", true);

    this.modalContainer.addEventListener("transitionend", () => {
      trapFocus(this.modalContainer, this.searchInput);
    });

    document.body.classList.add("overflow-hidden");
  }

  onClose() {
    this.removeAttribute("open");
    if (this.header) this.header.preventHide = false;

    document.body.classList.remove("overflow-hidden");

    this.modalContainer.addEventListener("transitionend", () => {
      removeTrapFocus();
      if (this.searchLink) this.searchLink.focus();
    });
  }

  onHandleKeyDown(event) {
    if (this.getAttribute("open")) {
      if (event.key === "Escape") {
        this.close();
      }
    }
  }

  disconnectedCallback() {
    this.header.removeEventListener("keydown", this.handleKeyDown);
  }
}

if (!customElements.get("header-search")) {
  customElements.define("header-search", HeaderSearch);
}
